export const textSemanticTokens = {
  text: {
    primary: {
      blue: { value: "colors.green.500" },
      black: { value: "colors.primary.black" },
      white: { value: "colors.primary.white" },
    },
    secondary: {
      green: { value: "colors.secondary.green" },
      blue: { value: "colors.secondary.blue" },
      red: { value: "colors.secondary.red" },
      yellow: { value: "colors.secondary.yellow" },
    },
    tertiary: {
      lightGreen: { value: "colors.tertiary.lightGreen" },
      lightBlue: { value: "colors.tertiary.lightBlue" },
      lightRed: { value: "colors.tertiary.lightRed" },
      lightYellow: { value: "colors.tertiary.lightYellow" },
    },
    gray: {
      "900": { value: "colors.gray.900" },
      "800": { value: "colors.gray.800" },
      "600": { value: "colors.gray.600" },
      "400": { value: "colors.gray.400" },
      "200": { value: "colors.gray.200" },
      "100": { value: "colors.gray.100" },
    },
    status: {
      success: { value: "colors.status.success" },
      error: { value: "colors.status.error" },
      warning: { value: "colors.status.warning" },
      info: { value: "colors.status.info" },
    },
  },
  fontSizes: {
    xxs: { value: "fontSizes.xxs" }, // 8px
    xs: { value: "fontSizes.xs" }, // 12px
    sm: { value: "fontSizes.sm" }, // 14px
    md: { value: "fontSizes.md" }, // 16px
    lg: { value: "fontSizes.lg" }, // 18px
    xl: { value: "fontSizes.xl" }, // 20px
    "2xl": { value: "fontSizes.2xl" }, // 24px
  },
  fontWeights: {
    normal: { value: "fontWeights.normal" }, // 400
    medium: { value: "fontWeights.medium" }, // 500
    semibold: { value: "fontWeights.semiBold" }, // 600
    bold: { value: "fontWeights.bold" }, // 700
  },
};
